export default "__VITE_ASSET__CT$YRHdv__"